import { render, staticRenderFns } from "./ChatComment.vue?vue&type=template&id=e0c849dc"
import script from "./ChatComment.vue?vue&type=script&lang=js"
export * from "./ChatComment.vue?vue&type=script&lang=js"
import style0 from "./ChatComment.vue?vue&type=style&index=0&id=e0c849dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports